import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

// Simple concurrency limiter for async tasks
export function createConcurrencyLimiter(maxConcurrent: number) {
    let active = 0
    const queue: (() => void)[] = []

    const next = () => {
        if (active >= maxConcurrent) return
        const fn = queue.shift()
        if (!fn) return
        active++
        fn()
    }

    return async function limit<T>(task: () => Promise<T>): Promise<T> {
        return new Promise<T>((resolve, reject) => {
            const run = () => {
                task()
                    .then((res) => resolve(res))
                    .catch((err) => reject(err))
                    .finally(() => {
                        active--
                        next()
                    })
            }
            queue.push(run)
            next()
        })
    }
}
